import axios from "axios";
import React, { useEffect, useState } from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts/highstock";

async function getBacklogData(company_id) {
  const newdata = [];
  await axios
    .get(`/api/backlog/company_id/${company_id}`)
    .then((res) => {
      res.data.forEach((item) => {
        newdata.push({
          x: Date.parse(item.date), // milliseconds 단위
          y: Number(item.amount ? (item.amount / 100000000).toFixed(1) : 0),
        });
      });
    })
    .finally(() => {});

  return newdata;
}

async function getStockChartData(company_id) {
  const newdata = [];
  await axios
    .get(`/api/stockprice/company_id/${company_id}`)
    .then((res) => {
      res.data.forEach((item) => {
        newdata.push({
          x: Date.parse(item.date), // milliseconds 단위
          open: item.open,
          high: item.high,
          low: item.low,
          close: item.close,
        });
      });
    });

  return newdata;
}

export default function BacklogsChart({ company_id, name }) {
  const base_options = {
    // 기초스타일
    title: {
      style: {
        color: "#111827",
        fontWeight: "bold",
      },
      text: `${name} 고용추이`,
    },
    chart: {
      // 차트 스타일 설정
      backgroundColor: "transparent",
      plotBorderWidth: 1,
      zoomType: "x",
      borderColor: "#E5E7EB",
    },
    accessibility: {
      enabled: false,
    },

    yAxis: [
      {
        title: {
          text: "잔고(억)",
          style: {
            color: "#374151",
          },
        },
        gridLineColor: "#E5E7EB",
        opposite: false,
        labels: {
          style: {
            color: "#374151",
          },
        },
      },
      {
        title: {
          // 주가차트
          text: "주가(원)",
          style: {
            color: "#374151",
          },
        },

        gridLineColor: "transparent",
        labels: {
          style: {
            color: "#374151",
          },
        },
      },
    ],
    rangeSelector: {
      buttonTheme: {
        // styles for the buttons
        fill: "none",
        stroke: "none",
        "stroke-width": 0,
        r: 8,
        style: {
          color: "#374151",
          fontWeight: "bold",
        },
        states: {
          select: {
            fill: "#E5E7EB",
            style: {
              color: "#1F2937",
            },
          },
        },
      },
      inputStyle: {
        color: "#374151",
      },
      labelStyle: {
        color: "#374151",
      },
    },

    tooltip: {
      borderRadius: 20,
      backgroundColor: "rgba(255, 255, 255, 0.95)",
      style: {
        color: "#333333",
      },
      shadow: {
        color: 'rgba(0,0,0,0.1)',
        width: 8,
        offsetX: 0,
        offsetY: 2
      },
      borderWidth: 0,
    },
    legend: {
      itemStyle: {
        color: "#374151",
        fontSize: "0.8rem",
      },
      itemHiddenStyle: {
        color: "#9CA3AF",
      },
      enabled: true,
    },
    navigator: {
      height: 20,
      series: {
        color: "#E5E7EB",
        lineColor: "#9CA3AF",
      },
      xAxis: {
        gridLineColor: "#E5E7EB",
      },
    },

    scrollbar: {
      // 스크롤바
      height: 1,
      barBackgroundColor: "#E5E7EB",
      trackBackgroundColor: "#F3F4F6",
    },
    plotOptions: {
      series: {
        lineWidth: 2,
        turboThreshold: 0,
      },
      candlestick: {
        lineColor: "#0EA5E9",
        color: "#0EA5E9",
        upLineColor: "#E11D48", // docs
        upColor: "#E11D48",
      },
    },
  };

  const [options, setOptions] = useState(base_options);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);

    getBacklogData(company_id)
      .then((res) => {
        // chart data 셋업

        // const xAxis = [
        //   {
        //     type: "datetime",
        //     crosshair: true,
        //     tickPositions: res.map((item) => item.x),
        //     labels: {
        //       formatter() {
        //         return Highcharts.dateFormat("%y-%m", this.value);
        //       },
        //     },
        //   },
        // ];

        const series = [
          {
            type: "area",
            data: res,
            name: "수주잔고",
            color: "rgba(34, 197, 94, 0.8)",
            fillColor: "rgba(34, 197, 94, 0.1)",
            marker: {
              radius: 3,
              lineColor: "#15803d",
            },
            lineWidth: 3,
          },
        ];

        const title = {
          style: {
            color: "#111827",
            fontWeight: "bold",
          },
          text: `${name} 수주잔고추이`,
        };

        getStockChartData(company_id).then((res) => {
          // chart data 셋업
          // xAxis.push({
          //   type: "datetime",
          // });
          series.push({
            type: "candlestick",
            data: res,
            events: {
              click: function (e) {
                console.log(e);
              },
            },
            name: "주가",
            yAxis: 1,
            // xAxis: 1,
            showInNavigator: true,
          });

          setOptions((prev) => {
            const temp = {
              ...prev,
              series,
              title,
              // xAxis,
            };
            return temp;
          });
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
    // return console.log("unmounting backlog chart");
  }, [company_id]);
  return (
    <div className="w-full">
      <div
        className={`w-full text-center bg-gray-100 text-gray-500 p-5 rounded my-2 text-xlg font-bold ${
          !isLoading && "hidden"
        }`}
      >
        ....loading....
      </div>
      <div className={`${isLoading && "hidden"}`}>
        <HighchartsReact
          highcharts={Highcharts}
          options={options}
          constructorType={"stockChart"}
        />
      </div>
    </div>
  );
}
